import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyA4VozWld3dJH_f0UZfA1RI0K1suO5dtA0",
  authDomain: "xyr-dashboard.firebaseapp.com",
  projectId: "xyr-dashboard",
  storageBucket: "xyr-dashboard.firebasestorage.app",
  messagingSenderId: "892830614283",
  appId: "1:892830614283:web:5be97b3aac542f8711d80e",
  measurementId: "G-NGFNDQMJR8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Analytics (optional) - wrapped in try/catch
let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (error) {
  console.warn('Analytics not initialized:', error);
}
export { analytics };

export default app;
